export default [
    { label: 'GPS Kendaraan', value: 'GPS Kendaraan', isDefault: true },
    { label: 'Smart Driver', value: 'Smart Driver' },
];